export default {
  async getTypeformClient() {
    return import("@typeform/embed")
  },
  async loadPopupStyles() {
    await import("@typeform/embed/build/css/popup.css")
  },
  async loadWidgetStyles() {
    await import("@typeform/embed/build/css/widget.css")
  },
  async openPopup(id: string, options: Object = {}) {
    await this.loadPopupStyles()
    const Typeform = await this.getTypeformClient()
    const { toggle } = Typeform.createPopup(id, options)
    toggle()
  },
  async openWidget(typeformId, options) {
    await this.loadWidgetStyles()
    const Typeform = await this.getTypeformClient()
    Typeform.createWidget(typeformId, options)
  },
}
